import { render } from "./MedicationsAdd.vue?vue&type=template&id=acc43b0e"
import script from "./MedicationsAdd.vue?vue&type=script&lang=js"
export * from "./MedicationsAdd.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/MedicationsAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "acc43b0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('acc43b0e', __exports__)) {
    console.log('reload')
    api.reload('acc43b0e', __exports__)
  }
  
  module.hot.accept("./MedicationsAdd.vue?vue&type=template&id=acc43b0e", () => {
    console.log('re-render')
    api.rerender('acc43b0e', render)
  })

}


export default __exports__